import DialogDeletionResource from "../DialogDeletionResource/DialogDeletionResource";
import DialogToggleActivationResource from "../DialogToggleActivationResource/DialogToggleActivationResource";

const DialogsActionsResource = ({
    isResourceActive,
    showDialogsActionResource,
    actions: {
        cancelToggleActivationResource,
        toggleActivationResource,
        deleteResource
    },
    data: {
        serviceName,
        serviceTypeName
    }
}) => {
    const { dialogShowToggleActivationResource, dialogShowDeletionResource } = showDialogsActionResource;
    return (
        <>
        <DialogToggleActivationResource
            dialogShow={dialogShowToggleActivationResource}
            cancelToggleActivationResource={cancelToggleActivationResource}
            toggleActivationResource={toggleActivationResource}
            serviceName={serviceName}
            isServiceActive={isResourceActive}/>
        <DialogDeletionResource
            dialogShow={dialogShowDeletionResource}
            serviceName={serviceName}
            serviceTypeName={serviceTypeName}
            deleteResource={deleteResource}/>
        </>
    );
}

export default DialogsActionsResource;